import onelps from '../../api';

export const logout = async function(dispatchFn) {
	try {
		const result = await onelps.actions.logout();

		return result;
	}
	catch(e) {
		dispatchFn({ type: 'SHOW_SERVER_ERROR' });
	}
};